// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"47a73304","239":"5a16aa93","455":"de7fa777"}[chunkId] + ".chunk.js";
};